import { Component, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { Device } from '../../devices/device.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Routine, RoutineDevice } from '../routines.model';
import { DeviceType, GROUP } from '../../devices/devices.constant';
import { DevicesService } from '../../devices/devices.service';
import { SessionStateService } from '../../../core/services/session-state.service';
import { SharedUtils } from '../../../shared/shared.utils';
import { RoutinesService } from '../routines.service';
import { SnackBarComponent } from '../../../layouts/gui-layout/sidebar-layout/snack-bar/snack-bar.component';
import { MatSnackBar } from '@angular/material';
@Component({
  selector: 'app-routines-dialog',
  templateUrl: './routines-dialog.component.html',
  styleUrls: ['./routines-dialog.component.scss']
})
export class RoutinesDialogComponent implements OnInit {

  @Output() create_action: EventEmitter<Routine> = new EventEmitter<Routine>();
  @Output() delete_action: EventEmitter<Routine> = new EventEmitter<Routine>();
  @Output() save_action: EventEmitter<Routine> = new EventEmitter<Routine>();
  @Output() edit_action: EventEmitter<Routine> = new EventEmitter<Routine>();



  devices = Array<RoutineDevice>();
  type;
  routine;
  deviceNumber;
  SharedUtils = SharedUtils;
  devicesToAdd = Array<RoutineDevice>();
  totalDevices = Array<RoutineDevice>();
  message: string;
  name: string;
  createDisabled = true;
  loading = true;

  constructor(
    private devicesService: DevicesService,
    private sessionStateService: SessionStateService,
    private routinesService: RoutinesService,
    public snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<RoutinesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.routine = data.routine;
    this.name = data.name;
    this.type = data.type;
    this.devices = data.devices;
 

  }
  ngOnInit() {
    this.loadDevices();

  }

  loadDevices() {
    this.loading = true;
    if (this.type == "New") {
      this.devicesService.getHouseModules(this.sessionStateService.getHouse().houseId, null, null, GROUP.SWITCH)
        .subscribe(switchDevices => {
          switchDevices.forEach(item => {
            const routineDevice = {
              'name': item.getName(),
              'moduleId': item.getModuleId(),
              'command': {
                'relayState': false
              }
            };
            this.totalDevices.push(routineDevice)
          });
        }, (err => {
        }))
        .add(() => {
          setTimeout(() => { this.loading = false }, 2000)
        });
    }
    if (this.type == "Edit") {
      this.devicesToAdd = [...this.devices];
      this.totalDevices = [...this.devices];
      this.devicesService.getHouseModules(this.sessionStateService.getHouse().houseId, null, null, GROUP.SWITCH)
        .subscribe(switchDevices => {
          switchDevices.forEach(item => {
            let hasDevice = this.isDeviceInDevices(item.getModuleId());
            if (!hasDevice) {
              const routineDevice = {
                'name': item.getName(),
                'moduleId': item.getModuleId(),
                'command': {
                  'relayState': false
                }
              };
              this.totalDevices.push(routineDevice)
            }
          });
        }, (err => {
        })).add(() => {
          setTimeout(() => { this.loading = false }, 2000);
        });

    }

    if (this.type == "View") {
      this.devicesToAdd = [...this.devices];
      this.totalDevices = [...this.devices];
      
          setTimeout(() => { this.loading = false }, 2000);

    }
    
    this.deviceNumber = this.devicesToAdd.length;

  }

  

  isDeviceInDevices(moduleId) {
    return (this.devices.find((device) => device.moduleId == moduleId));
  }

  changeDeviceState(moduleId) {
    for (let i = 0; i < this.devicesToAdd.length; i++) {
      if (this.devicesToAdd[i].moduleId == moduleId) {
        this.devicesToAdd[i].command.relayState = !this.devicesToAdd[i].command.relayState;
        return this.devicesToAdd[i];
      }
    }

  }

  isCreateDisabled(): boolean {
    return !(this.name.length >= 1 && this.devicesToAdd.length >= 1);
  }

  changeCheck(moduleId) {
    if (this.inDevicesToAdd(moduleId)) {
      /** Remove */

      for (let i = 0; i < this.devicesToAdd.length; i++) {
        if (this.devicesToAdd[i].moduleId == moduleId) {
          this.devicesToAdd.splice(i, 1)
          this.deviceNumber = this.devicesToAdd.length;
          return;
        }
      }
    } else {
      /** To Add */
      const device = {
        'moduleId': moduleId,
        'command': {
          'relayState': false,
        }
      };
      this.devicesToAdd.push(device);
      this.deviceNumber = this.devicesToAdd.length;
    }
  }

  inDevicesToAdd(moduleId): boolean {
    const device = this.devicesToAdd.find((device) => device.moduleId === moduleId);
    if (device) {
      return true;
    }
    return false;
  }

  loadingStatus() {
    return this.loading;
  }

  getRelayState(moduleId) {
    return this.devicesToAdd.find(function (element) {
      if (element.moduleId === moduleId && element.command.relayState == true) {
        return true;
      } else { return false; }
    })
  }

  onDelete() {
    this.onCloseDialog();
    this.routinesService.deleteRoutine(this.sessionStateService.getHouse().houseId, this.routine).subscribe(res => {
      if (!res) {
        this.delete_action.emit(this.routine);
      } else {
        this.message = "There was an error deleting this routine. Try again later";
        this.openSnackBar();
      }
    });
  }

  onEdit() {
    this.type="Edit";
    this.loading = true;
    this.devicesToAdd = [...this.devices];
      this.totalDevices = [...this.devices];
      this.devicesService.getHouseModules(this.sessionStateService.getHouse().houseId, null, null, GROUP.SWITCH)
        .subscribe(switchDevices => {
          switchDevices.forEach(item => {
            let hasDevice = this.isDeviceInDevices(item.getModuleId());
            if (!hasDevice) {
              const routineDevice = {
                'name': item.getName(),
                'moduleId': item.getModuleId(),
                'command': {
                  'relayState': false
                }
              };
              this.totalDevices.push(routineDevice)
            }
          });
        }, (err => {
        })).add(() => {
          setTimeout(() => { this.loading = false }, 2000);
        });
  }

  onSave() {
    this.isCreateDisabled();
    let response;
    let body;
    body = {
      name: this.name,
      config: this.devicesToAdd
    }

    this.routinesService.editRoutine(this.sessionStateService.getHouse().houseId, this.routine, body).subscribe(res => {
      if (!res) {
        this.onCloseDialog();
      } else {
        this.message = "There was an error editing this routine. Try again later"
        this.openSnackBar();
      }
    }).add(() => {
      this.save_action.emit(this.routine)
    });
  }

  onCreate() {
    let response;
    let body;
    body = {
      name: this.name,
      config: this.devicesToAdd
    }
    this.onCloseDialog();
    this.routinesService.createRoutine(this.sessionStateService.getHouse().houseId, body).subscribe(res => {
      if (res) {
        response = res;
        this.create_action.emit(response);
      }
      else {
        this.message = "There was an error creating this routine. Try again later"
        this.openSnackBar();

      }
    });

  }
  onCloseDialog() {
    this.dialogRef.close();
  }

  openSnackBar() {
    setTimeout(() => {
      this.snackBar.openFromComponent(SnackBarComponent, {
        data: this.message,
        duration: 3000,
        verticalPosition: 'bottom',
        panelClass: 'snackbar-panel',
      });
      setTimeout(() => {
        this.snackBar.dismiss();
      }, 3500);
    }, 500);
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/routines/routines-dialog/routines-dialog.component.ts